import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/events/tickets.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getEventTickets = (_0) => __async(void 0, [_0], function* ({ slug, lang, perPage, page }) {
  var _a, _b;
  try {
    const search = new URLSearchParams();
    search.append("lang", getLocaleOnly(lang));
    search.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    if (page) {
      search.append("page", page.toString());
    }
    if (perPage) {
      search.append("per_page", perPage.toString());
    }
    const data = yield fetchClient({
      url: `/event-ticket-details/${slug}?${search.toString()}`,
      includeAuth: false
    });
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getEventTicketsException"
    });
  }
});

export {
  getEventTickets
};
//# sourceMappingURL=chunk-X4LBTNIN.mjs.map